import { QrConfig } from './types';

import type QRCodeStyling from 'qr-code-styling';

/**
 * The margin that leaves `modules` whole modules of quiet zone around a code of
 * `moduleCount` modules drawn `size` px wide, as qr-code-styling lays out square
 * modules: floor((size - 2 * margin) / moduleCount) px each, centred.
 * ecommerce-api's QrCodePngRenderer draws per-unit codes with the same layout.
 */
export function quietZoneMargin(size: number, moduleCount: number, modules: number): number {
  const moduleSize = Math.max(1, Math.floor(size / (moduleCount + 2 * modules)));
  return Math.max(0, Math.floor((size - moduleCount * moduleSize) / 2));
}

/** Re-lays `qr` out with its style's quiet zone, once the module count of its payload is known. */
export function applyQuietZone(qr: QRCodeStyling, config: QrConfig): void {
  const modules = config.style.quietZoneModules;
  const moduleCount = qr._qr?.getModuleCount();
  if (modules === undefined || !moduleCount) {
    return;
  }
  qr.update({ margin: quietZoneMargin(config.size, moduleCount, modules) });
}
